import React from 'react'

import { Icon, CubeAIOutline, Community } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string, bool } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const ICON_SIZE = { width: '20', height: '20' }

// String icon keys (from the backend `create_ai_links`) -> Triangle UI glyphs.
const ICON_MAP = { cube_ai: CubeAIOutline, community: Community }

// "Create with AI" dropdown panel: a flat list anchored to the Create with AI
// trigger. Reuses the shared `.unified-nav__dropdown` card so it matches the
// Sellers Hub panel and renders in-flow inside the stacked mobile hamburger.
// The FREE TRIAL tag shows while a free trial is in progress or still attainable
// for the viewer (see Generator::SubscriptionState::FREE_TRIAL_TAG_TIERS).
function CreateAiDropdown({ id = undefined, links = EMPTY_ARRAY, showFreeTrialTag = false }) {
  return (
    <div className="unified-nav__dropdown" id={id}>
      <ul className="unified-nav__dropdown-list">
        {links.map((link) => {
          const IconComponent = ICON_MAP[link.icon]

          return (
            <li key={link.id} className="unified-nav__dropdown-item">
              <a
                className="unified-nav__dropdown-link cgt-body-base-semibold"
                href={link.href}
                data-track-label="Create with AI"
                data-track-text={link.trackText}
              >
                <span className="unified-nav__dropdown-item-icon">
                  {IconComponent && (
                    <Icon notSpaced color="dark" size={ICON_SIZE} svgComponent={IconComponent} />
                  )}
                </span>
                <span className="unified-nav__dropdown-item-label">{link.title}</span>
                {showFreeTrialTag && link.tag && (
                  <span className="unified-nav__dropdown-tag">
                    <span className="unified-nav__dropdown-tag-text">{link.tag}</span>
                  </span>
                )}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

CreateAiDropdown.propTypes = {
  id: string,
  links: arrayOf(shape({
    id: string,
    href: string,
    title: string,
    trackText: string,
    icon: string,
    tag: string,
  })),
  showFreeTrialTag: bool,
}

export default CreateAiDropdown
